import type { TrainingPolicyView } from "@/api";
import { registryDatasetDisplayLabel } from "@/modules/training/public";

/**
 * 정책의 학습 입력 표기.
 *
 * - registry 등록 스냅샷과 일치하면 그 표시명이다.
 * - 일치하는 것은 없고 학습 입력만 있으면 training-infra 전용 데이터셋이다(Training module 공개
 *   계약이 문구를 소유한다).
 * - 학습 입력이 없으면 null 이다.
 *
 * `dataset_id` 는 optional 이라 생략과 null 이 같은 뜻이다. `!== null` 로 읽으면 생략이 참이 되어
 * 표기가 달라진다. 그래서 판정을 여기 한 곳에만 둔다.
 *
 * 빈 값 표현은 위치마다 다르다(셀은 대시, 캡션은 행을 접는다). 호출부가 null 을 각자 처리한다.
 *
 * Args:
 *   policy: 정책 카탈로그 항목.
 *
 * Returns:
 *   표시 문자열, 또는 학습 입력이 없으면 null.
 */
export function policyDatasetLabel(policy: TrainingPolicyView): string | null {
  if (!policy.dataset_id && !policy.dataset_registry_ref) {
    return null;
  }
  return registryDatasetDisplayLabel(policy.dataset_registry_ref);
}
